export default class Model {
  init() {
  }

  uninit() {
  }

  properties() {
    return {};
  }

  emit() {
    this._observer.onChange();
  }
}



// WEBPACK FOOTER //
// ./modules/cliser/src/model.js